import makeAjaxRequest from "../makeAjaxRequest";
import fetchUrl from "../fetchUrl";

const AuraLogsServices = error => {
  makeAjaxRequest({
    method: "POST_NO_AUTH",
    url: fetchUrl("logs", "aura"),
    data: error
  });
};

export default AuraLogsServices;
